/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ToldsynByCvrResult
 */
export interface ToldsynByCvrResult {
    /**
     * 
     * @type {string}
     * @memberof ToldsynByCvrResult
     */
    cvr?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ToldsynByCvrResult
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ToldsynByCvrResult
     */
    toldsynResultsImported?: number;
    /**
     * 
     * @type {number}
     * @memberof ToldsynByCvrResult
     */
    toldsynResultsExported?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ToldsynByCvrResult
     */
    vinsImported?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ToldsynByCvrResult
     */
    vinsExported?: Array<string> | null;
}

export function ToldsynByCvrResultFromJSON(json: any): ToldsynByCvrResult {
    return ToldsynByCvrResultFromJSONTyped(json, false);
}

export function ToldsynByCvrResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ToldsynByCvrResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cvr': !exists(json, 'cvr') ? undefined : json['cvr'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'toldsynResultsImported': !exists(json, 'toldsynResultsImported') ? undefined : json['toldsynResultsImported'],
        'toldsynResultsExported': !exists(json, 'toldsynResultsExported') ? undefined : json['toldsynResultsExported'],
        'vinsImported': !exists(json, 'vinsImported') ? undefined : json['vinsImported'],
        'vinsExported': !exists(json, 'vinsExported') ? undefined : json['vinsExported'],
    };
}

export function ToldsynByCvrResultToJSON(value?: ToldsynByCvrResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cvr': value.cvr,
        'name': value.name,
        'toldsynResultsImported': value.toldsynResultsImported,
        'toldsynResultsExported': value.toldsynResultsExported,
        'vinsImported': value.vinsImported,
        'vinsExported': value.vinsExported,
    };
}


